import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V16C22 17.6569 20.6569 19 19 19H11.3333L8 21.5C7.17596 22.118 6 21.5301 6 20.5V19H5C3.34315 19 2 17.6569 2 16V6ZM5 5C4.44772 5 4 5.44772 4 6V16C4 16.5523 4.44772 17 5 17H6.5C7.32843 17 8 17.6716 8 18.5V19L10.1333 17.4C10.4795 17.1404 10.9006 17 11.3333 17H19C19.5523 17 20 16.5523 20 16V6C20 5.44772 19.5523 5 19 5H5Z"
	})
});
export default SvgMessage2Line;
